<div class="word-list">
  <ng-container *ngFor="let card of cards">
    <div (click)="show(card)" class="card c-pointer">
      <span class="japanese" [class.serif]="fontMode === 'serif'">
        {{ card.japanese }}
      </span>
      <span class="translation muted">
        {{ card.german.join(', ') }}
      </span>
      <div class="type">
        <app-word-type *ngIf="card.wordType" [card]="card"></app-word-type>
      </div>
    </div>
  </ng-container>
</div>